export const getActiveStepComponent = Symbol('getActiveStepComponent');
export const registerStepComponent = Symbol('registerStepComponent');
export const getStepByComponent = Symbol('getStepByComponent');
export const getKeepState = Symbol('getKeepState');
export const getStep = Symbol('getStep');
